import { render, staticRenderFns } from "./RestrictedMaterialPurchaseLimit.vue?vue&type=template&id=0a2dc47d&"
import script from "./RestrictedMaterialPurchaseLimit.vue?vue&type=script&lang=js&"
export * from "./RestrictedMaterialPurchaseLimit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports